import React, { useState, FC, useEffect } from 'react';
import { UnifiedKeypoints } from '@exerai/vision-engine-web';
import { ScanSessionResultsInsights, SideGaitResultsInsights } from '@/common/types';
import { SideGaitResultsInsightsOverlay } from './SideGaitResultsInsightsOverlay';
import { resultsInsightsAreSideGait } from './utils';

interface ResultsInsightsOverlayProps {
    resultsInsights: ScanSessionResultsInsights;
    poseLog: UnifiedKeypoints[];
    frame: number;
    imageWidth: number;
}

export const ResultsInsightsOverlayContainer: FC<ResultsInsightsOverlayProps> = (props) => {
    const { resultsInsights } = props;
    const [sideGaitResultsInsights, setSideGaitResultsInsights] = useState<SideGaitResultsInsights>();

    useEffect(() => {
        if (!resultsInsightsAreSideGait(resultsInsights)) {
            return;
        }
        setSideGaitResultsInsights(resultsInsights);
    }, [resultsInsights]);

    return (
        <>
            {sideGaitResultsInsights && (
                <SideGaitResultsInsightsOverlay {...props} resultsInsights={sideGaitResultsInsights} />
            )}
        </>
    );
};
